import React from 'react';
import Modifier from './Modifier';
import defaultMsg from '../../../../translations/lang/en-US.json';
import { injectIntl, intlShape, FormattedMessage } from 'react-intl';
import { addSplInstructions } from '../../actions';
import { get, uniqueId, groupBy, sortBy, uniq } from 'lodash';

class ListModifiers extends React.Component {
  constructor(props) {
    super(props);
  }
  updateDetorSelectedList(modifier, detor, list, doFocus = true) {
    let isDetorChecked;
    if (detor.option || detor.doption) {
      if (detor.selected === true && detor.option) {
        isDetorChecked = detor.option.reduce(
          (res, opt) => res || opt.isChecked,
          false
        );
        list.push(
          <Modifier
            autoFocus={doFocus && !isDetorChecked}
            key={uniqueId(`detor-${detor.id}-`)}
            clickedModifiers={this.props.clickedItemIdList}
            modifier={detor}
            id={modifier.id}
            type="detor"
            id={modifier.id}
            handleModifierChange={e =>
              this.props.handleModifierChange(
                this.refs.modifierContainer.scrollTop,
                e
              )
            }
          />
        );
      }
    }
    const options = get(detor, 'doption', get(detor, 'option', false));
    let isFocussed =
      doFocus && (isDetorChecked === undefined ? true : !!isDetorChecked);
    if (options && detor.selected === true) {
      options.forEach(subOption => {
        isFocussed = this.updateDetorSelectedList(
          modifier,
          subOption,
          list,
          isFocussed
        );
      });
    }
    return isFocussed;
  }
  returnDoptionModifiers(modifiersArray, type, list) {
    if (modifiersArray.length > 0) {
      modifiersArray.map(
        function(modifier) {
          const options = get(
            modifier,
            'option',
            get(modifier, 'doption', false)
          );
          if (modifier.selected) {
            options.map(subOption =>
              this.updateDetorSelectedList(modifier, subOption, list)
            );
          }
        }.bind(this)
      );
    }
    return list;
  }

  returnModifiers(modifiersArray, type, list) {
    if (modifiersArray.length > 0) {
      modifiersArray.map(
        function(item, i) {
          list.push(
            <Modifier
              clickedModifiers={this.props.clickedItemIdList}
              editCart={this.props.editCart}
              key={uniqueId(`clearfix-${item.id}-`)}
              id={item.id}
              modifier={item}
              type={type}
              id={item.id}
              handleModifierChange={e =>
                this.props.handleModifierChange(
                  this.refs.modifierContainer.scrollTop,
                  e
                )
              }
            />
          );
        }.bind(this)
      );
    }
    return list;
  }

  componentDidMount() {
    switch (this.props.scrollType) {
      case 'parent':
        document.getElementsByClassName(
          'addEditItemPopup'
        )[0].scrollTop = this.props.scrollBack;
        break;
      default:
        this.refs.modifierContainer.scrollTop = this.props.scrollBack;
        break;
    }
  }

  listModifiers() {
    const modifiers = [];
    const groupModifiers = [];
    const sampleArr = [];
    const list = [];
    this.returnModifiers(this.props.currentItem.forced, 'forced', modifiers);
    this.returnDoptionModifiers(
      this.props.currentItem.forced,
      'detor',
      modifiers
    );
    this.returnModifiers(
      this.props.currentItem.optional,
      'optional',
      modifiers
    );
    if (this.props.currentItem.forced.length > 1) {
      let test = this.props.currentItem.forced.find(
        forcedMod => forcedMod.selected === true
      );
      const grouped = groupBy(modifiers, 'props.id');
      Object.keys(grouped).map(key => sampleArr.push(grouped[key]));
      modifiers.map(modData => {
        sampleArr.map(grpMod => {
          grpMod.map(modGrp => {
            if (modGrp.props.id === modData.props.id) {
              groupModifiers.push(modGrp);
            }
          });
        });
      });
      var newDataArr = uniq(groupModifiers, function(e) {
        return e.key;
      });
      for (let i = 0; i < newDataArr.length; i++) {
        if (newDataArr[i]) {
          list.push(newDataArr[i]);
          if (i % 2 === 1) {
            list.push(<hr key={uniqueId('clearfix-')} />);
          }
        }
      }
    } else {
      for (let i = 0; i < modifiers.length; i++) {
        if (modifiers[i]) {
          list.push(modifiers[i]);
          if (i % 2 === 1) {
            list.push(<hr key={uniqueId('clearfix-')} />);
          }
        }
      }
    }
    return list;
  }

  handleSpecialInstruction(e) {
    let splChar = e.target.value;
    localStorage.setItem('specialInstructions', splChar);
    if (splChar.length > 50) {
      e.target.value = e.target.value.substring(0, 50);
      localStorage.setItem('specialInstructions', e.target.value);
      document.getElementById('errMessage').style.display = 'block';
    } else {
      document.getElementById('errMessage').style.display = 'none';
    }
  }

  render() {
    const errMessage = {
      display: 'none',
    };
    const messageMargin = {
      marginLeft: '10px',
      marginTop: 'auto',
    };
    const reOrderItems = get(this.props.currentItem, 'forced', 1);
    const optionalMod = get(this.props.currentItem, 'optional', 1);
    const list = this.listModifiers();
    return !this.props.currentItem ? null : (
      <div
        className="row modifier-container momentum-scroll"
        ref="modifierContainer"
        key={'modifier-container-'}
      >
        {list}
        {list && list.length > 0 ? (
          <div className="col-md-12 col-sm-12 col-xs-12 col-lg-12 spacer" />
        ) : null}
        <div
          className="col-md-12 col-sm-12 col-lg-12 col-xs-12 splInstructions"
          style={messageMargin}
        >
          <p>
            <FormattedMessage
              id="anySpecialInstructions"
              defaultMessage={defaultMsg.anySpecialInstructions}
            />
          </p>
          <input
            onKeyPress={() => this.props.restrictSubmit}
            onChange={e => this.handleSpecialInstruction(e)}
            defaultValue={this.props.defaultSpecialInstructions}
            type="text"
            className="form-control "
            ref={this.props.specialInstructionRef}
            id="splInstructions"
          />
          <p id="errMessage" style={errMessage}>
            <FormattedMessage
              id="max50Chars"
              defaultMessage={defaultMsg.max50Chars}
            />
          </p>
        </div>
      </div>
    );
  }
}

export default ListModifiers;



// WEBPACK FOOTER //
// ./src/views/dashboard/components/items/ListModifiers.jsx